var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnDestroy } from '@angular/core';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SearchConditionService } from '../../service/search-condition.service';
import { NotificationService } from 'src/app/shared/service/notification.service';
import { SearchService } from 'src/app/shared/service/search/search.service';
import { Subscription } from 'rxjs';
var NotificationRegisterComponent = /** @class */ (function () {
    function NotificationRegisterComponent(modalService, toastrService, searchConditionService, notificationService) {
        this.modalService = modalService;
        this.toastrService = toastrService;
        this.searchConditionService = searchConditionService;
        this.notificationService = notificationService;
        this.filter_enable = true;
        this.subscriptions = new Subscription();
    }
    NotificationRegisterComponent.prototype.ngOnInit = function () { };
    NotificationRegisterComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.unsubscribe();
    };
    NotificationRegisterComponent.prototype.open = function (content) {
        this.modalRef = this.modalService.open(content, {
            windowClass: 'search-tag-register-modal'
        });
    };
    NotificationRegisterComponent.prototype.registerNotification = function () {
        var _this = this;
        var params = __assign({}, this.searchParams, { search_tag_ids: this.searchService.getSearchTagIds() });
        var sub = this.notificationService
            .createNotificationFilter({
            name: this.name,
            mail_type: params.mail_type.includes('worker') ? 'worker' : 'project',
            conditions: params,
            enable: this.filter_enable
        })
            .subscribe(function (_) { return _this.toastrService.success('ボタン登録に成功しました。'); });
        this.subscriptions.add(sub);
        this.name = '';
        this.modalRef.close();
    };
    NotificationRegisterComponent.prototype.EnterOnRegister = function (event) {
        if (event.key === 'Enter' && !event.isComposing) {
            event.preventDefault();
            this.registerNotification();
        }
    };
    return NotificationRegisterComponent;
}());
export { NotificationRegisterComponent };
